var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLebanon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4189C24.8366 32.4189 32 25.2555 32 16.4189C32 7.58239 24.8366 0.418945 16 0.418945C7.16344 0.418945 0 7.58239 0 16.4189C0 25.2555 7.16344 32.4189 16 32.4189Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0.418945C9.65628 0.418945 4.17528 4.11051 1.58728 9.46245H30.412C27.824 4.11051 22.343 0.418945 15.9997 0.418945V0.418945Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 32.4192C22.343 32.4192 27.824 28.7276 30.412 23.3757H1.58728C4.17528 28.7276 9.65628 32.4192 15.9997 32.4192Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1742 19.2017L16.0002 11.5495L11.8263 19.2017H14.9567V21.2886H17.0437V19.2017H20.1742Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLebanon);
export default __webpack_public_path__ + "static/media/lebanon.e506f90d.svg";
export { ForwardRef as ReactComponent };